import { FAMILY_PROFILE_COLORS } from '~/familyAccount/types/familyAccounts.types'
import { PaymentGateways, StripeSubscriptionStatus } from '~/types/stripe-subscription'
import { Student } from '~/types/tutoring-api'

export interface Country {
  code: string
  flag: string
  name: string
}

export enum UserType {
  STUDENT = 'student',
  TEACHER = 'teacher',
  PARENT = 'parent',
  OTHER = 'other',
}

export interface CustomerRoleDataType {
  type: UserType
  desc: `${UserType}Description`
}

export enum UserSkill {
  WEAK,
  A_BIT_WEAK,
  AVERAGE,
  STRONG,
  VERY_STRONG,
}

export enum UserRole {
  ADMIN = 'admin',
  TUTOR = 'mentor',
  TEACHER = 'teacher',
  USER = 'user',
  FREE_USER = 'freeUser',
  // School platform (b2s) roles, signed into the JWT by hom-api. Distinct from TEACHER above, which
  // is the b2c teacher-access concept.
  SCHOOL_TEACHER = 'schoolTeacher',
  SCHOOL_STUDENT = 'schoolStudent',
}

export enum EmailStatus {
  AUTO_VERIFY_PENDING = 'auto-verify-pending',
  AUTO_VERIFY_IN_PROGRESS = 'auto-verify-in-progress',
  AUTO_VERIFY_SUCCESS = 'auto-verify-success',
  EMAIL_CHANGE_REQUIRED = 'email-change-required',
  USER_VERIFIED = 'user-verified',
}

export interface UserSubscription {
  id: string
  stripeProductId: string
  permissions: string[]
  userId: string
  subscriptionStatus: StripeSubscriptionStatus
  subscriptionId: string
  stripePriceId: string
  paymentGateway: PaymentGateways
}

export enum MobileAppSubscriptionStatus {
  TRIALING = 'trialing',
  ACTIVE = 'active',
  NON_ACTIVE = 'inactive',
}

export interface MobileAppSubscription {
  createdAt: string
  id: number
  purchaseState: number
  subscriptionPlatform: string
  subscriptionStatus: MobileAppSubscriptionStatus
  transactionId: string
  updatedAt: string
  userId: number
}

export interface IUser {
  id: number
  avatarPngUrl: string | null
  avatarUrl: string | null
  birthYear: string
  country: string | null
  curriculumCountryCode?: string
  curriculumStateCode?: string | null
  createdAt: string
  email: string | null
  emailVerified: boolean
  facebookEmail: string | null
  authEmail?: string | null
  facebookId: string | null
  firebaseToken: string
  fullName: string | null
  gradeLevelId: number | null
  nickname: string
  passwordReset: boolean
  phone: string | null
  role: UserRole
  skill: UserSkill | null
  timezone: string
  token: string
  userType: UserType | null
  wantsNewsletter: boolean
  yearsInSchool: number | null
  oauth?: Array<Record<string, string>>
  loggedInAt: string
  log: boolean
  emailStatus: EmailStatus
  stripeSubscription: UserSubscription[]
  isSubscriptionApplicable?: boolean
  isAllowedTrialSubscription: boolean
  userCountry?: string
  countryCode: string
  otherOnboardingSteps?: {
    [key: string]: boolean
  }

  validMobileAppSubscription: MobileAppSubscription | null
  studentInfo: Student
  pseudoId?: string
  mobileAppSubscription: MobileAppSubscription | null
  hasFreemiumTrial?: boolean
  hasFreemiumAvailed?: boolean

  /** @deprecated */
  birthdate: null
  feideUid: null
  firstName: null
  gradeLevelAt: null
  lastName: null
  school: null
  wantsMultgame: boolean
  zipcode: null
  hasPermissions: boolean

  familyProfiles: Array<{
    userId: number
    profileColor: FAMILY_PROFILE_COLORS
    nickname: string
    familyAdminId: number
    avatarPngUrl?: string
    avatarUrl?: string
    stripeSubscription?: UserSubscription[]
    validMobileAppSubscription?: MobileAppSubscription
  }>

  familyInfo: { hasLicense: boolean; isFamilyAdmin: boolean } | null

  shouldShowReferralModal?: boolean
}
